/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { Navi } from './components/navi';

import { IEcommAnnualReportsData } from './ecomm-annual-reports.data';
import { IReportsData, IEcommAnnualReportsProps } from './ecomm-annual-reports.props.autogenerated';

export interface IEcommAnnualReportsViewProps extends IEcommAnnualReportsProps<IEcommAnnualReportsData> {
  reports: React.ReactNode[];
  ebook: string;
}

/**
 *
 * EcommAnnualReports component
 * @extends {React.PureComponent<IEcommAnnualReportsProps<IEcommAnnualReportsData>>}
 */
class EcommAnnualReports extends React.PureComponent<IEcommAnnualReportsProps<IEcommAnnualReportsData>> {
  public state: any = { ebook: '' };

  public render(): JSX.Element | null {
    const EcommAnnualReportsProps = {
      ...this.props,
      reports: this._generateUrl(),
      ebook: this.state.ebook
    };

    return this.props.renderView(EcommAnnualReportsProps);
  }

  private _generateUrl(): JSX.Element[] | null {
    const { config } = this.props;

    if (config.reports?.length === 0 || !config.reports) {
      return [];
    }

    if (this.state.ebook === '') {
      const link = `${config.issuu}/docs/${config.reports[0].url}?mode=embed`;

      this.state = { ebook: link };
    }

    return (
      config.reports.map((item: IReportsData, index: number) => {
        const link = `${config.issuu}/docs/${item.url}?mode=embed`;
        const highlight = this.state.ebook === link ? true : false;

        return (
          <Navi
            key={index}
            active={highlight}
            name={item.name}
            url={link}
            callback={this._callback}
          />
        );
      })
    );
  }

  private _callback = (value: string) => {
    this.setState({ ebook: value });
  }
}

export default EcommAnnualReports;
